<template>
  <div>
    <div v-for="(day, d) in days" :key="'days' + d" class="grid_days">
      <div class="cell">{{ day.date }}</div>
      <div>
        <div v-for="(project, p) in day.projects" :key="'day.project' + p">
          <div v-for="(work, w) in project.work_types" :key="'day.project.work_types' + w">
            <div v-for="(report, r) in work.reports" :key="'day.work_types.report' + r">
              <FinanceSalarySliceShowTableByDaysItem
                :work="work"
                :report="report"
                :on-update="onUpdate"
                :ref="'item_' + d + '_' + p + '_work_type_' + w + '_' + r"
                :responsible-show="responsibleShow"
                :check-responsible="checkResponsible"
              />
            </div>
          </div>
          <div v-if="project.extras">
            <div class="fw500" :class="responsibleShow && checkResponsible ? 'grid_days_inner' : 'grid_days_responsible_inner'">
              <div class="cell">{{ project.name }}</div>
              <div class="cell">
                {{ $formatTime(getReportsSumByField(project.extras, 'employee_report')) }}
              </div>
              <div class="cell">
                <BaseCheckbox
                  v-if="checkboxData['item_' + d + '_' + p + '_extra_']"
                  v-model="checkboxData['item_' + d + '_' + p + '_extra_'].value"
                  @input="changeCheckboxData('item_' + d + '_' + p + '_extra_')"
                  :disabled="!$userCheckAccess({abilities: 'edit_salary'})
                    || checkboxData['item_' + d + '_' + p + '_extra_'].disabled"
                  class="mr-2"
                  :key="Number(checkboxData['item_' + d + '_' + p + '_extra_'].value)"
                />
                {{ getExtraSum('item_' + d + '_' + p + '_extra_', 'approved_report') }}
              </div>
              <div class="cell">
                {{ getExtraSum('item_' + d + '_' + p + '_extra_', 'paid_report') }}
              </div>
              <div class="cell">
                {{ '—' }}
              </div>
              <div class="cell">
                {{getReportsSumByField(project.extras, 'salary_sum') > 0 ? $formatCurrency(getReportsSumByField(project.extras, 'salary_sum')) + ' €' : '—' }}
              </div>
              <template v-if="responsibleShow && checkResponsible">
                <div class="cell responsibleCell">
                  {{ '—' }}
                </div>
                <div class="cell responsibleCell" v-if="getReportsSumByField(project.extras, 'project_responsible_salary_sum') > 0">
                  <BaseCheckbox
                    v-if="checkboxDataResponsible['item_' + d + '_' + p + '_extra_'] && !$userCheckAccess({abilities: 'edit_salary'}) || fillCheck > 0
                  || checkboxData['item_' + d + '_' + p + '_extra_'] && checkboxData['item_' + d + '_' + p + '_extra_'].disabled"
                    v-model="checkboxDataResponsible['item_' + d + '_' + p + '_extra_'].value"
                    @input="changeCheckboxResponsibleData('item_' + d + '_' + p + '_extra_')"
                    :disabled="!$userCheckAccess({abilities: 'edit_salary'})
                    || checkboxDataResponsible['item_' + d + '_' + p + '_extra_'].disabled_responsible"
                    class="mr-2"
                    :key="Number(checkboxDataResponsible['item_' + d + '_' + p + '_extra_'].value)"
                  />
                  {{ getReportsSumByField(project.extras, 'project_responsible_salary_sum') > 0
                  ? $formatCurrency(getReportsSumByField(project.extras, 'project_responsible_salary_sum')) + ' €' : '—' }}
                </div>
                <div class="cell responsibleCell" v-else>{{ '—' }}</div>
                <div class="cell responsibleCell">
                  {{ project.extras ? Object.values(project.extras)[0].project_responsible_name : '-' }}
                </div>
              </template>
              <div class="grid_days_inner_note">
                <div class="cell">
                  {{ localStorage.translations.pages.finance['period-table']['total-extra'] }}
                </div>
                <v-text-field dense hide-details outlined readonly class="f14 none_border"/>
              </div>
            </div>
            <div v-for="(work, w) in project.extras" :key="'day.project.extras' + w">
              <div v-for="(report, r) in work.reports" :key="'day.extras.report' + r">
                <FinanceSalarySliceShowTableByDaysItem
                  :work="work"
                  :report="report"
                  :on-update="onUpdate"
                  is-extra
                  :ref="'item_' + d + '_' + p + '_extra_' + w + '_' + r"
                  :responsible-show="responsibleShow"
                  :check-responsible="checkResponsible"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FinanceSalarySliceShowTableByDaysItem from './FinanceSalarySliceShowTableByDaysItem'
import BaseCheckbox from '../../../base/BaseCheckbox'

export default {
  name: 'FinanceSalarySliceShowTableByDays',
  components: {BaseCheckbox, FinanceSalarySliceShowTableByDaysItem},
  props: {
    data: {
      type: [Object, Array],
      default: () => {
        return {}
      },
    },
    onUpdate: {},
    start: {
      type: String,
      default: '11.04.2022',
    },
    end: {
      type: String,
      default: '24.04.2022',
    },
    current: Boolean,
    responsibleShow: Boolean,
  },
  computed: {
    days() {
      return this.$GetDaysByProjectsFinanceSalary(this.data, true)
    },
    checkResponsible() {
      let result = false
      for (let d in this.days) {
        for (let p in this.days[d].projects) {
          let arr = ['extras', 'work_types']
          for (let a in arr) {
            if (this.days[d].projects[p][arr[a]]) {
              for (let w in this.days[d].projects[p][arr[a]]) {
                for (let r in this.days[d].projects[p][arr[a]][w].reports) {
                  if (this.days[d].projects[p][arr[a]][w].reports[r] && this.days[d].projects[p][arr[a]][w].reports[r].responsible_user_id !== null)
                    result = true
                }
              }
            }
          }
        }
      }
      return result
    },
    daysData() {
      let result = []
      for (let d in this.days) {
        for (let p in this.days[d].projects) {
          let arr = ['extras', 'work_types']
          for (let a in arr) {
            if (this.days[d].projects[p][arr[a]]) {
              for (let w in this.days[d].projects[p][arr[a]]) {
                for (let r in this.days[d].projects[p][arr[a]][w].reports) {
                  let ref = 'item_' + d + '_' + p + '_' + arr[a].slice(0, -1) + '_' + w + '_' + r
                  if (this.$refs[ref])
                    result.push({
                      paid_report: this.$refs[ref] && this.$refs[ref][0] ? this.$refs[ref][0].toPaid : 0,
                      paid_notes: this.$refs[ref][0].toPaidNotes,
                      approved_report: this.$refs[ref][0].report['approved_report'],
                      has_paid_report: this.$refs[ref][0].report['paid_report'],
                      paid_report_responsible: this.$refs[ref] && this.$refs[ref][0] ? this.$refs[ref][0].toPaidResponsible : 0,
                      has_paid_report_responsible: this.$refs[ref][0].report['project_responsible_approved'],
                      ref: 'item_' + d + '_' + p + '_' + arr[a].slice(0, -1) + '_',
                      changedData: this.$refs[ref] && this.$refs[ref][0] ? this.$refs[ref][0].changedData : false,
                      changedDataResponsible: this.$refs[ref] && this.$refs[ref][0] ? this.$refs[ref][0].changedDataResponsible : false,
                      work: this.$refs[ref][0].work,
                      isExtra: arr[a] === 'extras',
                      id: this.$refs[ref][0].report.id
                    })
                }
              }
            }
          }
        }
      }
      return result
    },
    changedData() {
      return this.daysData.map(i => i.changedData).includes(true)
    },
    changedDataResponsible() {
      return this.daysData.map(i => i.changedDataResponsible).includes(true)
    },
    checkboxData() {
      let result = {}
      let list = {}
      for (let i in this.daysData) {
        if (!result[this.daysData[i].ref]) {
          result[this.daysData[i].ref] = []
        }
        result[this.daysData[i].ref].push({
          value: Number(this.daysData[i]['paid_report']) > 0,
          has_paid_report: Number(this.daysData[i]['has_paid_report']) > 0,
        })
      }
      for (let i in result) {
        result[i] = {
          value: result[i].every(e => { return e.value })
            ? true
            : result[i].every(e => { return !e.value })
              ? false
              : null,
          disabled: result[i].every(e => {return e.has_paid_report}),
        }
      }
      list = result
      return list
    },
    checkboxDataResponsible() {
      let result = {}
      let list = {}
      for (let i in this.daysData) {
        if (!result[this.daysData[i].ref]) {
          result[this.daysData[i].ref] = []
        }
        result[this.daysData[i].ref].push({
          value: Number(this.daysData[i]['paid_report_responsible']) > 0,
          has_paid_report_responsible: Number(this.daysData[i]['has_paid_report_responsible']) > 0,
        })
      }
      for (let i in result) {
        result[i] = {
          value: result[i].every(e => { return e.value })
            ? true
            : result[i].every(e => { return !e.value })
              ? false
              : null,
          disabled_responsible: result[i].every(e => {return e.has_paid_report_responsible}),
        }
      }
      list = result
      return list
    },
    fillCheck() {
      let result = 0
      for (let i in this.daysData) {
        if (this.daysData[i].isExtra === true && Number(this.daysData[i].work.project_responsible_salary_sum) > 0)
          result = result + 1
      }
      return result;
    }
  },
  methods: {
    getExtraSum(ref, field) {
      let list = this.daysData.filter(i => i.ref.includes(ref))
      let result = list.map(i => i[field]).reduce((sum, cur) => {
        return Number(cur) + sum
      }, 0)
      return result > 0 ? this.$formatTime(result) : ''
    },
    changeCheckboxData(ref) {
      let value = this.checkboxData[ref].value
      for (let i in this.$refs)
        if (i.includes(ref))
          this.$refs[i][0].setPaidChanges(!value)
    },
    changeCheckboxResponsibleData(ref) {
      let value = this.checkboxDataResponsible[ref].value
      for (let i in this.$refs) {
        if (i.includes(ref)) {
          this.$refs[i][0].setPaidResponsibleChanges(!value)
        }
      }
      
    },
    getReportsSumByField(items, field) {
      if (field === 'salary')
        return Object.values(items).reduce((sum, current) => {
          return sum + current[field]
        }, 0)
      return Object.values(items).map((data) => data.reports).reduce((sum, current) => {
        return (sum + current.reduce((sum, current) => {
          return sum + current[field]
        }, 0))
      }, 0)
    },
    async changeExtra(day) {
      let tmp = this.days[day] ? Object.values(this.days[day].projects)[0] : Object.values(this.days[day].projects)[0]
      let extras = tmp.extras
      let data = []
      for (let e in extras) {
        let reports = extras[e].reports
        for (let r in reports) {
          let temp = {}
          temp.id = reports[r].id
          temp['paid_hours'] = tmp['extras_paid']
            ? reports[r]['paid_report'] || reports[r]['approved_report']
            : 0
          data.push(temp)
          temp['paid_notes'] = tmp['extras_paid'] ? reports[r]['paid_notes'] || '' : ''
        }
      }
      if (this.onUpdate) this.onUpdate(data, tmp['extras_paid'] > 0, true)
    },
    currentDate: function (date, start, end) {
      if (date && start && end) {
        let d = new Date(date)
        let s = new Date(start)
        let e = new Date(end)
        return d >= s && d <= e
      }
      return false
    },
  },
}
</script>
